/**
 * 生成唯一key
 * @returns {string}
 */
import { FormPatternTypes } from "./core/type";
import { uid } from "./core/uid";

function generateUUID(prefix) {
    return (prefix || "") + uid();
}
const isValid = val => val !== undefined && val !== null;

function getConfig(item, infoEdit, parentFormItemLayout, layout) {
    let disabled = false;
    if (infoEdit) {
        disabled = !item.editEnable;
    } else {
        disabled = item.disabled;
    }
    let rules;
    if (item.rules) {
        if (typeof item.rules != "object") {
            rules = JSON.parse(item.rules);
        } else {
            rules = item.rules;
        }
    }
    let customConfig = {};
    if (item.customConfig) {
        if (typeof item.customConfig != "object") {
            try {
                customConfig = JSON.parse(item.customConfig);
            } catch (e) {
                console.log(item.name, "customStr json error");
            }
        } else {
            customConfig = item.customConfig;
        }
    }
    let formItemLayout = {};
    if (layout === "horizontal") {
        formItemLayout = {
            labelCol: item.labelCol || parentFormItemLayout.labelCol,
            wrapperCol: item.wrapperCol || parentFormItemLayout.wrapperCol,
        };
    }
    let {
        placeholder,
        label,
        pattern = FormPatternTypes.editable,
        allowClear,
        showSearch,
        onSearch,
        extra,
        validateTrigger,
    } = item;
    if (pattern === FormPatternTypes.readPretty) {
        extra = "";
    }
    return {
        placeholder,
        allowClear,
        showSearch,
        onSearch,
        label,
        disabled,
        rules,
        pattern,
        validateTrigger,
        ...customConfig,
        extra,
        formItemLayout,
    };
}

export { generateUUID, getConfig, isValid };
